import React, { Component } from "react";
import arrowRight from "../img/right-arrow.svg";
import arrowLeft from "../img/left-arrow.svg";
import landingData from "../landingData.json";

export default class Landing extends Component {
  render() {
    return (
      <div className="website">
        <div className="website__content website-content">
          <div className="title">
            <div className="title__img">
              <img src={arrowLeft} height="25px" alt="arrow right" />
            </div>
            <div className="title__heading">
              <h1>Landing pages</h1>
            </div>
            <div className="title__img">
              <img src={arrowRight} height="25px" alt="arrow right" />
            </div>
          </div>
          {landingData.map((landingItem, index) => {
            return (
              <div key={index} className="website-content__item">
                <div className="website__info">
                  <span className="website__date">{landingItem.date}</span>
                  <span className="website__name">
                    Web site name:{" "}
                    <span className="website__name--text">
                      {landingItem.name}
                    </span>
                  </span>
                  <p className="website__desc">{landingItem.text}</p>
                  <div className="tags">
                    Tags:
                    {landingItem.tags.map((tag, index) => {
                      return (
                        <span key={index} className="tags__item">
                          {tag}
                        </span>
                      );
                    })}
                  </div>
                </div>
                <div className="website__screen">
                  <a
                    href={landingItem.link}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={landingItem.img} alt="screenshot" />
                  </a>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}
